import { queryClient } from '../../../ReactQuery';
import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { SnippetsFilterParams } from '../../../../shared/snippets';

import { getSnippetByIdQueryKey, getSnippetsBaseQueryKey } from './shared';

function rejectSnippets(userRevisionLocator: string, params: SnippetsFilterParams) {
  return post(`/api/revisions/${nuc(userRevisionLocator)}/snippets/reject`, params);
}

/**
 * Allow users of this hook to specify additional query keys to invalidate.
 */
export type RejectSnippetsInvalidationOptions = {
  revisionLocator?: string;
  id?: string;
};

/**
 * useRejectSnippets is a hook that rejects snippets.
 */
export default function useRejectSnippets(
  userRevisionLocator: string,
  { revisionLocator, id }: RejectSnippetsInvalidationOptions = {},
) {
  return useToastedMutation({
    mutationFn: (params: SnippetsFilterParams) => rejectSnippets(userRevisionLocator, { ...params, path: params.path ?? '/' }),
    onSuccess: () => {
      // Invalidate (and refetch) the snippets for this user revision locator.
      queryClient.invalidateQueries({ queryKey: getSnippetsBaseQueryKey(userRevisionLocator) });
      if (revisionLocator) {
        queryClient.invalidateQueries({ queryKey: getSnippetsBaseQueryKey(revisionLocator) });
      }
      if (id) {
        queryClient.invalidateQueries({ queryKey: getSnippetByIdQueryKey(userRevisionLocator, id) });
      }
    },
    successToastMessage: 'Snippet(s) rejected successfully.',
    errorToastMessage: 'Failed to reject snippet(s).',
  });
}
